import React, { Context, createContext, ReactElement, useMemo } from 'react';

import { getResponsiveFallback } from '../../../shared/helpers/getResponsiveFallback';
import { IParentProps } from '../../../shared/types/IParentProps';
import { IResponsive } from '../../../shared/types/IResponsive';

import { GRID_CELL_SIZE } from './GRID_CELL_SIZE';

export const GridCellContext: Context<IResponsive<GRID_CELL_SIZE>> = createContext<IResponsive<GRID_CELL_SIZE>>({
    sm: GRID_CELL_SIZE.COLUMN_1,
    md: GRID_CELL_SIZE.COLUMN_1,
    lg: GRID_CELL_SIZE.COLUMN_1,
});

export type IGridCellProviderProps = IParentProps & {
    smSize?: GRID_CELL_SIZE;
    mdSize?: GRID_CELL_SIZE;
    lgSize?: GRID_CELL_SIZE;
};

export function GridCellProvider (props: IGridCellProviderProps): ReactElement {
    const {
        smSize,
        mdSize,
        lgSize,
        children,
    }: IGridCellProviderProps = props;

    const value: IResponsive<GRID_CELL_SIZE> = useMemo((): IResponsive<GRID_CELL_SIZE> => {
        const sizes: IResponsive<GRID_CELL_SIZE> = {
            sm: smSize,
            md: mdSize,
            lg: lgSize,
        };

        return {
            sm: getResponsiveFallback(sizes, 'sm'),
            md: getResponsiveFallback(sizes, 'md'),
            lg: getResponsiveFallback(sizes, 'lg'),
        };
    }, [smSize, mdSize, lgSize]);

    return (
        <GridCellContext.Provider value={value}>
            {children}
        </GridCellContext.Provider>
    );
}
